// extracted by css-extract-rspack-plugin
export default {"root":"d73451e","main":"a06fd00","title":"ef48cbc","search":"c1f52b8","stub":"d17b8cd","footer":"a444efa","toasts":"d0bffd7","toast":"f598ee3"};